import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import TransactionsList from './TransactionsList';
import { EmptyTransactionsList } from './EmptyTransactionsList';
import i18nContext from 'components/i18n-context';
import TransactionsFilter from './TransactionsFilter';
import Pagination from '../Pagination/Pagination';
import { useMediaQuery } from 'services/useMediaQUery';
import { MEDIA_QUERY } from 'services/utils';
import { NewContainer } from 'uikit/NewContainer/NewContainer';
import './LatestTransactions.scss';

const LatestTransactions = ({ customerNumber, transactionsStore }) => {
  const i18n = useContext(i18nContext);

  useEffect(() => {
    if (transactionsStore.isCardAccountTransactions) {
      transactionsStore.setIsCardAccountTransactions(false);
    } else if (transactionsStore.isRedirectFromAccountCard) {
      transactionsStore.setIsRedirectFromAccountCard(false);
      transactionsStore.clearFiltersWithoutWallets();
    } else {
      transactionsStore.clearFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (customerNumber) {
      transactionsStore.getTransactions(customerNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    customerNumber,
    transactionsStore.filters.from_date,
    transactionsStore.filters.to_date,
    transactionsStore.filters.currencies,
    transactionsStore.filters.wallets,
    transactionsStore.filters.types,
    transactionsStore.filters.transfer_types,
    transactionsStore.filters.statuses,
    transactionsStore.transactionSort.sort_column,
    transactionsStore.transactionSort.sort_direction,
    transactionsStore.pagination.size,
    transactionsStore.pagination.page
  ]);

  const handleSortChange = (sortData) => transactionsStore.setTransactionSort(sortData);
  const isMobile = useMediaQuery(MEDIA_QUERY.MOBILE);

  const handleSetCurrentPage = (pageNumber) => {
    transactionsStore.setTransactionPage(pageNumber);
    transactionsStore.getTransactions(customerNumber);
  };

  const handleSetPageSize = (size) => {
    transactionsStore.setTransactionPageSize(size);
  };

  return (
    <NewContainer
      className={'transactions-container-main content-card-wrapper'}
      header={i18n.getMessage('container.Transactions')}
    >
      <TransactionsFilter isMobile={isMobile} />
      {transactionsStore.transactionList.length ? (
        <>
          <TransactionsList
            isLoading={transactionsStore.isLoading}
            onChangeSort={handleSortChange}
            transactions={transactionsStore?.transactionList}
            sortData={transactionsStore?.transactionSort}
          />
          <Pagination
            isShowPaginationSize={true}
            paginationSize={transactionsStore.pagination.size}
            handleChangePaginationSize={handleSetPageSize}
            isLoading={transactionsStore.isLoading}
            currentPage={transactionsStore.pagination.page}
            numberOfPages={transactionsStore.totalPages}
            setCurrentPage={handleSetCurrentPage}
          />
        </>
      ) : (
        <EmptyTransactionsList />
      )}
    </NewContainer>
  );
};

LatestTransactions.propTypes = {
  customerNumber: PropTypes.string,
  transactionsStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  customerNumber: stores.userStore.userData.account?.account_number,
  transactionsStore: stores.transactionsStore
}))(observer(LatestTransactions));
